import { computed } from 'vue'
import store from '../store'

const auth_user = computed(() => store.getters['Auth/permissions'])

const canView = (name: string) => {
  if (!auth_user.value) {
    return false
  }

  return auth_user.value.find((element: any) => {
    if (element.name === name) {
      return true
    }
  })
}

export default canView
